<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>外線・内線対応表</h5>
      </div>
      <div class="col-4 d-flex justify-content-end p-0">
        <button v-show="isAdmin" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>
        <!-- <button v-show="isAdmin" type="button" class="btn-sm btn-outline-primary" v-on:click="importCsv">CSVをimportする</button> -->
        <button v-show="isAdmin" type="button" class="btn-sm btn-outline-success" v-on:click="autoFillName">個人貸与番号から表示名を反映する</button>
      </div>
    </div>
    <div id="seach_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-9 form-group">
        <form class="input-group" @submit.prevent="search(true)">
          <input type="text" class="form-control" v-model="searchKey" placeholder="外線番号、内線番号、表示名">        
          <div class="input-group-append">
              <button class="btn btn-secondary" type="submit">
                <img class="search-solid" src="/search-solid.svg">
              </button>
          </div>
        </form>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-9">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th                scope="col" style="width:70px">#</th>
              <th                scope="col" style="width:150px">外線番号</th>
              <th                scope="col" style="width:150px">内線番号</th>
              <th                scope="col" >表示名</th>
              <th v-if="isAdmin" scope="col" style="width:100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(pair, index) in pairs" v-bind:key="pair.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ pair.phoneNumber }}</td>
              <td>{{ pair.extensionNumber }}</td>
              <td>{{ pair.contactName }}</td>
              <td>
                <button v-if="isAdmin" type="button" class="btn-sm btn-light" v-on:click="modify(pair.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-2">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  src: {
    authority
  },
  data: function(){
    return {
      pairs: [],
      message: '',
      searchKey: '',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
    }
  },
  mounted() {
    if(this.$store.getters.standardPhoneSearch.searchKey !== ''){
      this.searchKey = this.$store.getters.standardPhoneSearch.searchKey
    }
    if(this.$store.getters.standardPhoneSearch.currentIndex !== 0){
      this.currentIndex = this.$store.getters.standardPhoneSearch.currentIndex
    }
    if(this.$store.getters.hospital.id !== 0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isAdmin: function () {
      var overAdmin = authority.isAdmin.concat(authority.isSuper)
      return overAdmin.includes(Number(this.$store.state.user.privilege))
    },
    isUseFunction: function() {
      return this.serviceName === 'Nichibyo'
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/standardPhone/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/standardPhone/modify/'+id))
    },
    importCsv() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/standardPhone/import'))
    },
    autoFillName() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.post("/api/standardPhone/autoFillName/", {
            hospitalId: this.$store.getters.hospital.id
          },{
            headers: this.headers(accessToken),
          }).then(res => {
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('反映処理が実施されました。')
              this.search(false)
            }
          }).catch(err => {
            this.message = err.message
          })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .post("/api/standardPhone/list/" + hospitalId +  "/"+ offset, {
              hospitalId : hospitalId,
              searchKey: this.searchKey,
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.pairs = response.data.data.pairs
              this.gridCount = this.pairs.length
              this.$store.commit('standardPhoneSearch',{
                searchKey: this.searchKey,
                currentIndex: this.currentIndex
              })
            })
            .catch(err => {
              this.message = err.message
              this.$store.commit('standardPhoneSearch',{
                searchKey: '',
                currentIndex: 0
              })
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
button {
  margin-right: 10px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>